import React from "react";
import VideoRecorder from "./VideoRecorder";

export default function App() {
  return (
    <div className="app">
      <h1>Face Video & Vitals Collection</h1>
      <VideoRecorder />
    </div>
  );
}
